<template>
  <ol class="breadcrumb">
    <li
      v-for="(item, index) in linkItems"
      :key="index"
      :class="[item.addClasses, sharedClasses, addLinkClasses]"
      role="presentation"
    >
      <CLink
        v-if="index == 0"
        v-bind="Object.assign({}, item, { addClasses: null, text: null })"
      >
        <!-- <CIcon name="cil-home"/> -->
        <span class="breadcrumb-text">{{ item.text }}</span>
      </CLink>
      <CLink
        v-else
        v-bind="Object.assign({}, item, { addClasses: null, text: null })"
      >
        <!--reset DMA Details filter to Dashboard -->
        <span
          class="breadcrumb-text"
          v-if="item.text == 'Dashboard'"
          @click="resetDMADashboard($event)"
          >{{ item.text }}</span
        >
        <!--reset DMA Details filter to Dashboard end-->
        <span class="breadcrumb-text" v-else>{{ item.text }}</span>
      </CLink>
    </li>
    <li v-if="lastItem" :class="lastItemClasses" role="presentation">
      <div v-if="items.length == 1">
        <CLink
          v-bind="Object.assign({}, lastItem, { addClasses: null, text: null })"
        >
          <!-- <CIcon name="cil-home"/> -->
          <span class="breadcrumb-text">{{ lastItem.text }}</span>
        </CLink>
      </div>
      <span v-else class="breadcrumb-text" v-text="lastItem.text"></span>
    </li>
    <slot></slot>
  </ol>
</template>

<script>
import CLink from "../link/CLink";
import { EventBus } from "../../components/Events";
export default {
  name: "CBreadcrumb",
  components: {
    CLink,
  },
  props: {
    items: Array,
    addClasses: [String, Array, Object],
    addLinkClasses: [String, Array, Object],
    addLastItemClasses: [String, Array, Object],
  },
  computed: {
    lastItem() {
      return this.navItems ? this.navItems[this.navItems.length - 1] : null;
    },
    linkItems() {
      return this.navItems ? this.navItems.slice(0, -1) : [];
    },
    navItems() {
      let items = this.items;
      if (!items[items.length - 1].text.trim()) {
        items.pop();
      }
      return items;
    },
    sharedClasses() {
      return [this.addClasses, "breadcrumb-item"];
    },
    lastItemClasses() {
      return [
        "active",
        this.lastItem.addClasses,
        this.sharedClasses,
        this.addLastItemClasses,
      ];
    },
  },
  methods: {
    resetDMADashboard(e) {
      //reset DMA Details filter to Dashboard and not Project
      setTimeout(() => {
        EventBus.$emit("DMA-Filter", "Dashboard");
      }, 1000);
    },
  },
};
</script>

<style lang="scss" scoped>
.breadcrumb {
  height: 56px;
  border-left: solid thin white !important;
  flex-grow: 4;
}
.breadcrumb svg {
  margin-right: 5px;
}
.breadcrumb-item {
  padding-top: 4px;

  a {
    color: #fff;
  }
}
.breadcrumb-item > .active:hover {
  text-decoration: none;
}
// Remove after Confirmation
// .breadcrumb-text {
//   vertical-align: middle;
// }
</style>